import React, { Component } from "react";
import MainMenu from "./mainMenu";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import "./styles/nav.css";
import { projSelectorConstants } from "../../_constants/projSelectorConstants";
import { modalTabIds } from "../../_constants/modalTabIds";
import mainTabActions from "../../_actions/mainTabActions";
import { DOCTYPE } from "../../_constants/docTypeConstants";
import { actionScripts } from "../../_helpers/actionScripts";
import NotificationModal from "../notifCenter/NotificationModal";

class MainNavBar extends Component {
  state = {
    mainMenuIsOpen: false,
    mainNavIsOpen: false,
    notifModalOpen: false, // State to control the notification modal
  };

  toggleMainNav = () => {
    this.setState({
      mainNavIsOpen: !this.state.mainNavIsOpen,
    });
  };

  toggleMainMenu = () => {
    this.setState({
      mainMenuIsOpen: !this.state.mainMenuIsOpen,
    });
  };

  toggleNotifModal = () => {
    this.setState((prevState) => ({
      notifModalOpen: !prevState.notifModalOpen,
    }));
  };

  handleClick_overtime = (e) => {
    e.preventDefault();
    actionScripts.OPEN_OVERTIME.run();
  };

  handleClick_prefs = (e) => {
    e.preventDefault();
    actionScripts.OPEN_USER_PREFS.run();
  };

  handleClick_issues = (e) => {
    e.preventDefault();
    actionScripts.OPEN_ISSUE_TRACKER.run();
  };

  handleClick_about = (e) => {
    e.preventDefault();
    actionScripts.OPEN_ABOUT.run();
  };

  handleClick_notifications = (e) => {
    e.preventDefault();
    // Toggle the notification modal instead of dispatching an action
    this.toggleNotifModal();
  };

  renderUserMenu = () => {
    const { authentication, toggleLoginModal, toggleAlert_logoutConfirm } = this.props;
    if (authentication.loggedIn)
      return (
        <DropdownMenu right>
          <DropdownItem disabled>View My Profile...</DropdownItem>
          <DropdownItem onClick={this.handleClick_overtime}>Overtime...</DropdownItem>
          <DropdownItem onClick={this.handleClick_prefs}>Preferences...</DropdownItem>
          <DropdownItem divider />
          <DropdownItem onClick={toggleAlert_logoutConfirm}>Log Out</DropdownItem>
        </DropdownMenu>
      );
    else
      return (
        <DropdownMenu right>
          <DropdownItem onClick={toggleLoginModal}>Log In</DropdownItem>
        </DropdownMenu>
      );
  };

  render() {
    const {
      authentication,
      toggleAdrSearchModal,
      toggleReportSelectionModal,
      toggleCreateAdrFromExistingModal,
      toggleProjAssignmentProjSelectionModal,
    } = this.props;
    return (
      <React.Fragment>
        <Navbar className="main-navbar sticky-top py-1" color="dark" dark expand="md">
          <NavbarBrand
            className="py-0"
            onClick={(e) => {
              e.preventDefault();
            }}
            href="/"
          >
            <div
              className={
                this.state.mainMenuIsOpen ? "dms-main-menu-open" : "dms-main-menu-closed"
              }
              id="mainMenuHamburger"
              onClick={this.toggleMainMenu}
            >
              <FontAwesomeIcon className="mx-2 mt-2" icon="bars" />
            </div>
            {this.state.mainMenuIsOpen && (
              <MainMenu
                onClose={this.toggleMainMenu}
                toggleReportSelectionModal={toggleReportSelectionModal}
                toggleCreateAdrFromExistingModal={toggleCreateAdrFromExistingModal}
                toggleProjAssignmentProjSelectionModal={
                  toggleProjAssignmentProjSelectionModal
                }
              />
            )}
          </NavbarBrand>
          <NavbarToggler onClick={this.toggleMainNav} />
          <Collapse isOpen={this.state.mainNavIsOpen} navbar className="py-0">
            <Nav className="ml-auto py-0" navbar>
              {authentication.loggedIn && (
                <React.Fragment>
                  <kbd className="navbar-username py-0 px-2 my-auto mr-3">
                    {authentication.user.username}
                  </kbd>
                  <NavItem title="Notifications">
                    <NavLink
                      className="py-0 pr-0 mr-0"
                      href="#"
                      onClick={this.handleClick_notifications}
                    >
                      <FontAwesomeIcon className="fa-lg" icon="bell" />
                      <span className="badge badge-pill badge-danger badge-dms-notifications">
                        {authentication.user.notifications
                          ? authentication.user.notifications.length
                          : 0}
                      </span>
                    </NavLink>
                  </NavItem>
                  <UncontrolledDropdown nav inNavbar className="py-0" title="User Profile">
                    <DropdownToggle nav className="py-0 pl-1 mr-1">
                      <FontAwesomeIcon className="fa-lg" icon="user" />
                    </DropdownToggle>
                    {this.renderUserMenu()}
                  </UncontrolledDropdown>
                  <span className="mx-2 text-muted">|</span>
                  <UncontrolledDropdown nav inNavbar className="py-0 zindex-fixed" title="Search">
                    <DropdownToggle nav className="py-0 pl-1">
                      <FontAwesomeIcon className="fa-lg" icon="search" />
                    </DropdownToggle>
                    <DropdownMenu right>
                      {/*<DropdownItem header>Create New</DropdownItem>
                      <DropdownItem disabled>ARE/ASR Daily Report...</DropdownItem>
                      <DropdownItem disabled>RE/SR Daily Report...</DropdownItem>
                      <DropdownItem disabled>Progress Payment...</DropdownItem>
                      <DropdownItem divider />*/}
                      <DropdownItem header>Open/Search</DropdownItem>
                      <DropdownItem
                        onClick={toggleAdrSearchModal(
                          0,
                          {
                            type: projSelectorConstants.USER_ASSIGNED,
                            lookupId: authentication.user.userId,
                          },
                          modalTabIds.ADR_SEARCH
                        )}
                      >
                        ARE/ASR Daily Report...
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                  <span className="mx-2 text-muted">|</span>
                  <NavItem title="Report a Bug">
                    <NavLink
                      className="py-0 pr-0 pl-1 mr-2"
                      href="#"
                      onClick={this.handleClick_issues}
                    >
                      <FontAwesomeIcon className="fa-lg" icon="bug" />
                    </NavLink>
                  </NavItem>
                  <NavItem title="About">
                    <NavLink
                      className="py-0 pr-0 pl-1 mr-2"
                      href="#"
                      onClick={this.handleClick_about}
                    >
                      <FontAwesomeIcon className="fa-lg" icon="question-circle" />
                    </NavLink>
                  </NavItem>
                </React.Fragment>
              )}
            </Nav>
          </Collapse>
        </Navbar>
        <NotificationModal isOpen={this.state.notifModalOpen} toggle={this.toggleNotifModal} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  mainMenuOptions: state.mainMenu.items,
  authentication: state.authentication,
  notifications: state.authentication.user ? state.authentication.user.notifications : [],
});

export default connect(mapStateToProps)(MainNavBar);
